import { createExternalSystemTableConfig } from './externalSystem';

export const operatorSystem = createExternalSystemTableConfig({
  columns: {},
});
